/**
 * `groups` — un groupe de galeries (base plateforme, 4.1).
 */
import { z } from 'zod';
import { CHAMPS_DOCUMENT, idSchema, slugSchema, withAudit } from './commun.js';
/** Ce qu'un groupe partage entre ses galeries (5.2). */
export const partageGroupeSchema = z.object({
    chiffres: z.boolean().default(true),
    oeuvres: z.boolean().default(true),
    ventes: z.boolean().default(true),
    /** Titres et dates des échéances de coffre, jamais les fichiers. */
    echeancesCoffre: z.boolean().default(true),
    contacts: z.boolean().default(false),
});
export const groupSchema = withAudit(z.object({
    _id: idSchema,
    nom: z.string(),
    slug: slugSchema,
    galeries: z.array(idSchema).default([]),
    partage: partageGroupeSchema,
}));
export const groupCreationSchema = groupSchema.omit(CHAMPS_DOCUMENT);
export const groupMiseAJourSchema = groupCreationSchema.partial();
//# sourceMappingURL=groups.js.map